import React, { useState, useEffect, useRef } from "react";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

import ethLisbon from "../../images/hackathon/eth-lisbon.png";
import denverHackathon from "../../images/hackathon/ai-buildlabs.png";
import ethGlobalTapei from "../../images/hackathon/eth-global-tapei.png";
import ethGlobalNewdelhi from "../../images/hackathon/eth-newdelhi.svg";
import ethGlobalBuenosaires from "../../images/hackathon/eth-ba.svg";
import ethGlobalPrague from "../../images/hackathon/eth-global-prague.png";

import { MobileNavigationEvents } from "../global/MobileNavigationEvents";

const events = [
  { image: ethGlobalNewdelhi, date: "September 26-28", year: "2025", title: "ETH Global New Delhi", link: "https://ethglobal.com/events/newdelhi" },
  { image: ethGlobalBuenosaires, date: "November 21-23", year: "2025", title: "ETH Global Buenos Aires", link: "https://ethglobal.com/events/buenosaires" },
];

export const Events = () => {
  const [isDesktop, setIsDesktop] = useState(false);
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [totalSlides, setTotalSlides] = useState(0);

  // Check if window is defined before accessing it
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsDesktop(window.innerWidth >= 1025);

      const handleResize = () => {
        setIsDesktop(window.innerWidth >= 1025);
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  // Initialize total slides when Splide is ready
  useEffect(() => {
    if (typeof window !== "undefined" && sliderRef.current?.splide) {
      setTotalSlides(sliderRef.current.splide.Components.Controller.getEnd() + 1);
    }
  }, []);

  const handlePrev = () => sliderRef.current?.splide?.go("-1");
  const handleNext = () => sliderRef.current?.splide?.go("+1");

  const splideOptions = {
    type: "slide",
    perPage: 3,
    perMove: 1,
    pagination: false,
    rewind: true,
    arrows: false, // We control arrows manually
    breakpoints: {
      1025: { perPage: 1 },
    },
  };

  if (isDesktop) {
    return (
      <section className="upcoming-hackathons-section container" id="events-carousel">
        <div className="mt-5 pb-5 text-left">
          <span className="zg-label bg-orange mb-5">Discover</span>
          <h2 className="mt-3 h3 mb-5">Upcoming Hackathons</h2>
        </div>
        <div className="hackathon-cards grid-layout" >
          {events.map((event, index) => (
            <div className="col" key={index}>
              <a href={event.link} className="hackathon-card" target="_blank" rel="noopener noreferrer">
                <div className="card-image">
                  <img src={event.image} alt={event.title} />
                </div>
                <div className="card-details">
                  <div className="card-details-date">
                    <p className="date">{event.date}</p>
                    <p className="year">{event.year}</p>
                  </div>
                  <h3>{event.title}</h3>
                  <a href="#" className="join-now-btn">Join Now</a>
                </div>
              </a>
            </div>
          ))}
        </div>
      </section>
    );
  }

  return (
    <section className="upcoming-hackathons-section mt-5 pt-5">
      <div className="container">
        <div className="header mt-5 pb-5">
          <span className="zg-label bg-orange mt-5">DISCOVER</span>
          <h2 className="mt-5 h3 mb-5">Upcoming Hackathons</h2>
        </div>
        <div className="hackathon-cards mt-5" id="events-carousel">
          <Splide
            ref={sliderRef}
            hasTrack={false} 
            options={splideOptions}
            onMove={(splide, newIndex) => setCurrentSlide(newIndex + 1)}
          >
            <SplideTrack>
              {events.map((event, index) => (
                <SplideSlide key={index}>
                  <a href={event.link} className="hackathon-card" target="_blank" rel="noopener noreferrer">
                    <div className="card-image">
                      <img src={event.image} alt={event.title} />
                    </div>
                    <div className="card-details">
                      <div className="card-details-date">
                        <p className="date">{event.date}</p>
                        <p className="year">{event.year}</p>
                      </div>
                      <h3>{event.title}</h3>
                      <a href="#" className="join-now-btn">Join Now</a>
                    </div>
                  </a>
                </SplideSlide>
              ))}
            </SplideTrack>
          </Splide>
        </div>
      </div>
      <div id="hackathon-mobile" className="position relative">
        <MobileNavigationEvents currentSlide={currentSlide} totalSlides={totalSlides} onPrev={handlePrev} onNext={handleNext} />
      </div>
    </section>
  );
};
